interface TravelUpdatePayload {
    eventType: 'travel_updated';
    travelId: string;
    title: string;
    userName: string;
    userEmail: string;
    supervisorEmail: string;
}

export const sendTravelUpdateToN8n = async (
    travelId: string,
    title: string,
    userName: string,
    userEmail: string,
    supervisorEmail: string
): Promise<{ success: boolean; error?: string }> => {
    const N8N_WEBHOOK_URL = import.meta.env.VITE_N8N_WEBHOOK_TRAVEL_UPDATE_URL;

    if (!N8N_WEBHOOK_URL) {
        return { success: false, error: 'Webhook URL no configurada' };
    }

    try {
        const payload: TravelUpdatePayload = {
            eventType: 'travel_updated',
            travelId,
            title,
            userName,
            userEmail,
            supervisorEmail
        };

        const response = await fetch(N8N_WEBHOOK_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
        });

        if (!response.ok) {
            console.error(' Error n8n:', response.status);
            return { success: false, error: `HTTP ${response.status}` };
        }

        return { success: true };

    } catch (error) {
        console.error('Error enviando webhook:', error);
        return {
            success: false,
            error: error instanceof Error ? error.message : 'Error desconocido'
        };
    }
};